




















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import dayjs from 'dayjs';
@Component
export default class FormItem extends Vue {
  @Prop({default: ''}) readonly value!: string;
  @Prop({required: true}) fieldName!: string;
  @Prop() placeholder?: string;
  @Prop() type?: string;
  onValueChanged(value: string) {
    console.log(value);
    this.$emit('update:value', value);
  }
  x(isoString: string) {
    return dayjs(isoString).format('YYYY-MM-DD');
  }
}
